<template>
  <div>
    <h1>{{ title }}</h1>
    <button @click="changeTitle">제목 변경</button>
    <ul>
      <li v-for="item in items" :key="item">{{ item }}</li>
    </ul>
    <button @click="addItem">아이템 추가</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "간단한 Vue 예제",
      items: ["첫 번째 아이템", "두 번째 아이템"],
    };
  },
  methods: {
    changeTitle() {
      this.title = "제목이 변경되었습니다!";
    },
    addItem() {
      this.items.push(`새 아이템 ${this.items.length + 1}`);
    },
  },
};
</script>

<style scoped>
h1 {
  color: green;
}
button {
  margin: 5px;
  padding: 5px 10px;
  background-color: lightblue;
  border: none;
  border-radius: 5px;
}
ul {
  list-style: none;
  padding: 0;
}
li {
  margin: 5px 0;
}
</style>

